import PortalIdParser from 'PortalIdParser';
export const CPQ_QUOTE_TEMPLATE_PATH = '@hubspot/cpq-theme/templates/cpq-quote.hubl.html';
export const getCPQQuoteEditorRoute = contentId => `/quote/${PortalIdParser.get()}/editor/${contentId}/content?redirectUrl=${encodeURIComponent(window.location.href)}`;